import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://techcare.live";

export const Seo = ({ title, description, path = "/" }) => {
  // index.html carries a home-page canonical + description for crawlers that don't run JavaScript.
  // Once a page renders its own, remove those so every page has exactly one of each.
  useEffect(() => {
    document.querySelectorAll("head [data-static-seo]").forEach((el) => el.remove());
  }, []);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${SITE}${path}`} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${SITE}${path}`} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};
